import React, { useState, useEffect, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import Alert from 'react-s-alert';
import moment from 'moment';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import ReactTooltip from "react-tooltip";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import Regions from '../Common/Region';

const AddinvoiceData = {
    InvoiceID: 0,
    AmountPaid: 0,
    Balance: 0,
    Comments: "",
    CreatedDate: moment(new Date()),
    Days: 0,
    CreatedBy: 0,
    IsDeleted: 0
};

const InvoiceNotes = () => {

    const { CurrentTheme } = useContext(ThemeContext);
    // eslint-disable-next-line
    const [companyInfo, setCompanyInfo] = useState([]);
    const [InvoicesInfo, setInvoicesInfo] = useState([]);
    const [InvoicesData, setInvoicesData] = useState([]);
    const [SelectedInvoicesInfo, setSelectedInvoicesInfo] = useState([]);
    const [displayQuotationInfo, setdisplayQuotationInfo] = useState("none");
    const [displayInvoiceNoteAddModel, setdisplayInvoiceNoteAddModel] = useState("none");
    const [QuotationsSnapShot, setQuotationsSnapShot] = useState({});
    const [InvoiceNotesData, setInvoiceNotesData] = useState([]);
    const [AddInvoiceNotesData, setAddInvoiceNotesData] = useState(AddinvoiceData);
    const [PendingAmount, setPendingAmount] = useState(0);
    const [RegionSymbol, setRegionSymbol] = useState({});

    useEffect(() => {
        FetchInvoices();

        if (localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setCompanyInfo(companyDetails);
            var region = Regions.filter(r => r.Code === companyDetails.CountryCode);
            if (region.length > 0) {
                setRegionSymbol(region[0]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchInvoices = () => {
        Axiosfetch(baseURL + "GetAllInvoicesByNotes", "GET", null, getInvoicesSuccess, Failure);
    };

    const getInvoicesSuccess = (data) => {
        if (data.length > 0) {
            var invoices = [];
            setInvoicesData(data);
            data.forEach(invoice => {
                let invoiceNumber = "Invoice/" + (invoice.Quotation.Customer.Name.split(' ')[0].trim()) + "/#" +
                    invoice.ID + "/" + moment(invoice.CreatedDate).local().format("DDMMYYYY");
                invoices.push({ value: invoice.ID, label: invoiceNumber });
            });

            setInvoicesInfo(invoices);
        }
        else {
            setInvoicesData([]);
            setInvoicesInfo([]);
        }
    };

    const getInvoiceNotesFromInvoice = (invoiceData) => {

        let invoice = parseInt(invoiceData ? invoiceData.value : 0);
        if (invoice > 0) {
            let selectedInvoice = InvoicesData.filter(i => i.ID === invoice);
            if (selectedInvoice.length > 0) {
                setSelectedInvoicesInfo(selectedInvoice);
                setPendingAmount(selectedInvoice[0].Quotation.TotalAmount);
            }

            Axiosfetch(baseURL + "GetInvoiceNotesByInvoiceID", "POST", { InvoiceID: invoice }, GetInvoiceNotedataSuccess, Failure);
        }
        else {
            setSelectedInvoicesInfo([]);
        }
    };

    const GetInvoiceNotedataSuccess = (data) => {
        if (data.length > 0) {
            setInvoiceNotesData(data);
            setPendingAmount(data[data.length - 1].Balance);
        }
        else {
            setInvoiceNotesData([]);
        }
    };

    const hideQuotationInfo = () => {
        setdisplayQuotationInfo("none");
    };

    const showInvoiceNoteAdd = () => {
        setdisplayInvoiceNoteAddModel("block");
    };

    const hideInvoiceNoteAdd = () => {
        setdisplayInvoiceNoteAddModel("none");
    };

    const FetchQuotationDetailsByID = (invoiceID) => {
        let InvoiceID = parseInt(invoiceID);
        Axiosfetch(baseURL + "InvoiceSnapShotByID", "POST", { InvoiceID: InvoiceID }, GetInvoiceSnapShot, Failure);
    };

    const GetInvoiceSnapShot = (data) => {
        if (data.length > 0) {
            setdisplayQuotationInfo("block");
            setQuotationsSnapShot(data[0]);
        }
        else {
            Alert.error("Quotation Snapshot not found. Generate PDF to get the snapshot", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            setdisplayQuotationInfo("none");
            setQuotationsSnapShot({});
        }
    };

    const onTextChange = (e) => {
        let value = e.target.value;
        setAddInvoiceNotesData({ ...AddInvoiceNotesData, [e.target.name]: value });
    };

    const onNumberChange = (e) => {
        let value = e.target.value === "" ? 0 : parseFloat(e.target.value);
        setAddInvoiceNotesData({ ...AddInvoiceNotesData, [e.target.name]: value });
    };

    const AddInvoiceNoteDetails = () => {
        var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
        if (userData && SelectedInvoicesInfo.length > 0) {
            const userID = parseInt(JSON.parse(userData).ID);
            AddInvoiceNotesData.InvoiceID = SelectedInvoicesInfo[0].ID;
            AddInvoiceNotesData.CreatedDate = moment(new Date()).format('MM/DD/YYYY, HH:mm:ss');
            AddInvoiceNotesData.Balance = PendingAmount - AddInvoiceNotesData.AmountPaid;
            AddInvoiceNotesData.CreatedBy = userID;
            AddInvoiceNotesData.ReminderStartDate = AddInvoiceNotesData.startDate ? moment(AddInvoiceNotesData.startDate).startOf('day').format('MM/DD/YYYY, HH:mm:ss') : null;
            AddInvoiceNotesData.ReminderEndDate = moment(new Date(AddInvoiceNotesData.startDate)
                .setDate(new Date().getDate() + parseInt(AddInvoiceNotesData.Days))).endOf('day').format('MM/DD/YYYY, HH:mm:ss')
            if (ValidateNotes(AddInvoiceNotesData)) {
                Axiosfetch(baseURL + "CreateInvoiceNotes", "POST", AddInvoiceNotesData, CreateNotesSuccess, Failure);
            }
        }
        else {
            Alert.error("Error occured While Generating Quotation. Please login to the application again before attempting the steps.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const ValidateNotes = (NotesInfo) => {
        let productErr = "";
        if (NotesInfo.AmountPaid === 0) {
            productErr = "Please enter valid Amount";
        }
        else if (NotesInfo.AmountPaid > PendingAmount) {
            productErr = "Amount cannot be greater than Balance Amount";
        }
        else if (NotesInfo.Comments.trim() === "") {
            productErr = "Please enter valid Comments";
        }

        if (productErr !== "") {
            Alert.error(productErr, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    };

    const DeleteNotes = (noteID) => {

        let notesID = parseInt(noteID);
        if (notesID > 0) {
            Axiosfetch(baseURL + "DeleteInvoiceNotes", "POST", { ID: notesID }, DeleteNotesSuccess, Failure);
        }
    };

    const DeleteNotesSuccess = (data) => {
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });

        if (SelectedInvoicesInfo.length > 0) {
            getInvoiceNotesFromInvoice({ value: SelectedInvoicesInfo[0].ID });
        }
    }

    const CreateNotesSuccess = (data) => {
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });

        if (SelectedInvoicesInfo.length > 0) {
            getInvoiceNotesFromInvoice({ value: SelectedInvoicesInfo[0].ID });
        }

        setAddInvoiceNotesData(AddinvoiceData);

        hideInvoiceNoteAdd();
    };

    const onReminderChange = (date) => {
        setAddInvoiceNotesData({ ...AddInvoiceNotesData, "startDate": date });
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="offset-md-3 col-md-5 col-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Payment Logs</h5>
                    </div>
                    <div className="col-md-4 col-12">
                        <div style={{ width: "90%" }}>
                            <Select isClearable={true} isSearchable={true} placeholder="Select Invoice"
                                options={InvoicesInfo}
                                onChange={getInvoiceNotesFromInvoice}></Select>
                        </div>
                    </div>
                    <div className="col-md-12" style={{ height: "75vh" }}>
                        {SelectedInvoicesInfo.length > 0 && <div>
                            <div className="row" style={{ marginTop: "20px", marginLeft: "5px", marginRight: "5px", height: "70vh" }}>
                                <div className="col-md-5" style={{
                                    borderRight: "1px solid #ccc",
                                    borderTop: "1px solid #ccc", paddingTop: "10px"
                                }}>
                                    <div className="row" style={{ paddingBottom: "10px", borderBottom: "1px solid #ccc" }}>
                                        <div className="offset-md-1 col-md-10 col-sm-10 align-center">Invoice Information</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12" style={{ marginBottom: "15px", marginTop: "25px" }}>Invoice Number :<span style={{ fontWeight: "600" }}> {SelectedInvoicesInfo[0].ID}</span></div>
                                        <div className="col-md-12" style={{ marginBottom: "15px" }}>Created Date :<span style={{ fontWeight: "600" }}>  {moment(SelectedInvoicesInfo[0].CreatedDate).local().format("DD MMM YYYY hh:mm:ss A")}</span></div>
                                        <div className="col-md-12" style={{ marginBottom: "15px" }}>Customer :<span style={{ fontWeight: "600" }}>  {SelectedInvoicesInfo[0].Quotation.Customer.Name}</span></div>
                                        <div className="col-md-12" style={{ marginBottom: "15px" }}>Amount : <span style={{ fontWeight: "600" }}> {SelectedInvoicesInfo[0].Quotation.TotalAmount} /-</span></div>
                                        <div className="col-md-12" style={{ marginBottom: "15px" }}>Quantity : <span style={{ fontWeight: "600" }}> {SelectedInvoicesInfo[0].Quotation.TotalQuantity}</span></div>
                                        <div className="col-md-12" data-tip="Click to see Invoice" onClick={(QuotationID) => FetchQuotationDetailsByID(SelectedInvoicesInfo[0].ID)} style={{ marginBottom: "15px", cursor: "pointer" }}>Invoice : <span style={{ color: "#005582", fontWeight: "600" }}>
                                            Invoice Snapshot</span>
                                        </div>
                                        <div className="col-md-10" style={{
                                            margin: "15px",
                                            padding: "10px", borderRadius: "6px", color: "white", backgroundColor: (PendingAmount > 0 ? "#ff7f7f" : "#66b266")
                                        }}>Balance : <span style={{ fontWeight: "600" }}> {PendingAmount} /-</span></div>
                                    </div>
                                </div>
                                <div className="col-md-7" style={{
                                    borderL: "1px solid #ccc",
                                    borderTop: "1px solid #ccc", paddingTop: "10px"
                                }}>
                                    <div className="row" style={{ paddingBottom: "10px", borderBottom: "1px solid #ccc" }}>
                                        <div className="offset-md-1 col-md-10 col-sm-10 align-center">Logs</div>
                                        <div data-tip="Add Invoice Notes" onClick={showInvoiceNoteAdd}
                                            className={`col-md-1 col-sm-1 align-right cursor ${CurrentTheme}Color`}>
                                            <FontAwesomeIcon icon={faPlus} />
                                        </div>
                                    </div>
                                    <div className="tableQuotationRecordsStyle" style={{ height: "60vh", scrollbarColor: "#005582 transparent", padding: "0 10px 10px 10px" }}>
                                        {InvoiceNotesData.length > 0 && InvoiceNotesData.map((notes, index) => (
                                            <div className={(notes.Balance !== 0 ? (index % 2 === 0 ? "NotesStick noteOdd" : "NotesStick noteEven") : "NotesStick noteCompleted")}
                                                style={{ backgroundColor: (notes.Balance !== 0 ? (index % 2 === 0 ? "#e8d6f4" : "#eef1b6") : "#93c993"), borderRadius: "6px", padding: "10px" }}>
                                                {index > 0 && (<div className={index % 2 === 0 ? "NotesStickArrowOdd" : "NotesStickArrowEven"}></div>)}
                                                <table style={{ width: "100%" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <div>Balance : <span style={{ fontWeight: "600", verticalAlign: "text-bottom" }}>{notes.Balance}</span>
                                                                    {RegionSymbol.Symbol && (<FontAwesomeIcon style={{ fontSize: "1.3rem" }} className="padding-topLeft" icon={RegionSymbol.Symbol}></FontAwesomeIcon>)}
                                                                    {RegionSymbol.Symbol === null && (<div style={{ padding: "5px 0 0 10px" }}>{RegionSymbol.Currency}</div>)}</div>
                                                            </td>
                                                            <td>
                                                                <div style={{ position: "relative" }}>
                                                                    <div>Amount Paid :  <span style={{ fontWeight: "600", verticalAlign: "text-bottom" }}>{notes.AmountPaid}</span>
                                                                        {RegionSymbol.Symbol && (<FontAwesomeIcon style={{ fontSize: "1.3rem" }} className="padding-topLeft" icon={RegionSymbol.Symbol}></FontAwesomeIcon>)}
                                                                        {RegionSymbol.Symbol === null && (<div style={{ padding: "5px 0 0 10px" }}>{RegionSymbol.Currency}</div>)}
                                                                    </div>
                                                                    {index === InvoiceNotesData.length - 1 &&
                                                                        (<span title="Delete" className="DeleteNotesStyle" onClick={(noteID) => DeleteNotes(notes.ID)}><FontAwesomeIcon icon={faTimes} /></span>)}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="2">
                                                                <div>Comments : <span style={{ fontWeight: "600", wordBreak: "break-word" }}>{notes.Comments}</span></div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div>Date : <span style={{ fontWeight: "600" }}>{moment(notes.CreatedDate).local().format("DD MMM YYYY hh:mm:ss A")}</span></div>
                                                            </td>
                                                            <td>
                                                                <div>By : <span style={{ fontWeight: "600" }}>{notes.User.FirstName + " " + notes.User.LastName}</span></div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        ))
                                        }
                                        {InvoiceNotesData.length === 0 && (<div className="NoNotesStyle">No Logs Added.</div>)}
                                    </div>
                                </div>
                            </div>
                            <ReactTooltip></ReactTooltip>
                        </div>}
                        {SelectedInvoicesInfo.length === 0 &&
                            <div style={{ marginTop: "35px", textAlign: "center" }}>
                                <div style={{ padding: "10px", backgroundColor: "#ccc", textAlign: "center" }}> Please Select Invoice.</div>
                            </div>}
                    </div>
                </div>
            </div>
            <div id="myModalQuotationInfo" className="modal" style={{ display: displayQuotationInfo }}>
                <div style={{ width: "80%" }} className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Invoice SnapShot</span>
                        <span className="close" onClick={hideQuotationInfo}>&times;</span>
                    </div>
                    <div className="row" style={{ marginTop: "10px", marginBottom: "10px" }}>
                        <div className="col-md-12 col-sm-12">
                            {
                                QuotationsSnapShot.ImageData !== undefined && <img width="100%" src={QuotationsSnapShot.ImageData} alt="QuotationImage"></img>
                            }

                            {
                                QuotationsSnapShot.ImageData === undefined && (<div className="offset-md-1 col-md-10 col-sm-10 align-center">No Quotation History Available</div>)
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModalInvoiceNoteInfo" className="modal" style={{ display: displayInvoiceNoteAddModel }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Add Payment Logs</span>
                        <span className="close" onClick={hideInvoiceNoteAdd}>&times;</span>
                    </div>
                    <div className="row" style={{ marginTop: "10px", marginBottom: "10px" }}>
                        <div className="col-md-12 col-sm-12">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <h5>Invoice</h5>
                                        </td>
                                        <td>
                                            {SelectedInvoicesInfo.length > 0 &&
                                                "Invoice/" + SelectedInvoicesInfo[0].Quotation.Customer.Name.split(' ')[0].trim() + "/#" + SelectedInvoicesInfo[0].ID + "/" + moment(SelectedInvoicesInfo[0].CreatedDate).local().format("DDMMYYYY")}

                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>Balance</h5>
                                        </td>
                                        <td>
                                            {PendingAmount}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>Amount Paid<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <input type="number" min="0.00" step="any" name="AmountPaid"
                                                className="form-control"
                                                onChange={e => onNumberChange(e)}
                                                value={AddInvoiceNotesData.AmountPaid}></input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>Next Reminder</h5>
                                        </td>
                                        <td>
                                            <DatePicker name="startDate" selected={AddInvoiceNotesData.startDate}
                                                onChange={onReminderChange}
                                                className="form-control"
                                                dateFormat="MMMM d, yyyy"></DatePicker>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>Reminder Days</h5>
                                        </td>
                                        <td>
                                            <input type="number" min="0.00" step="any" name="Days"
                                                className="form-control"
                                                onChange={e => onNumberChange(e)}
                                                value={AddInvoiceNotesData.Days}></input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>Comments<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <textarea
                                                onChange={e => onTextChange(e)}
                                                rows="1"
                                                className="form-control" name="Comments" value={AddInvoiceNotesData.Comments}></textarea>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" style={{ textAlign: "right" }}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={AddInvoiceNoteDetails}>Save</button>
                                                    <button type="button" className="btn btn-default" onClick={hideInvoiceNoteAdd}>Close</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceNotes;